<template>
  <div>
    <Table
      stripe
      ref="table"
      :columns="columns"
      :data="list"
      :show-header="false"
    ></Table>
  </div>
</template>

<script>
export default {
  name: 'ExpandTable',
  props: {
    value: Object,
  },
  data() {
    return {
      list: [],
      fieldTypeList: [
        {
          id: 1,
          name: 'array',
        },
        {
          id: 2,
          name: 'string',
        },
        {
          id: 3,
          name: 'interger',
        },
        {
          id: 4,
          name: 'number',
        },
        {
          id: 5,
          name: 'file',
        },
        {
          id: 6,
          name: 'object',
        },
        {
          id: 7,
          name: 'boolean',
        },
      ],
      rootType: '2',
      currentIndex: 0,
      isShowVariableModal: false,
      addType: 2,
    }
  },
  computed: {
    columns() {
      let columns = [
        {
          title: ' ',
          type: 'expand',
          render: (h, { row }) => {
            if (+this.value.type === 6) {
              /* eslint-disable */
              return h('expand-table', {
                props: {
                  row: row,
                },
                on: {
                  input: (e) => {
                    this.list = e
                  },
                },
              })
            } else {
              return h('div', '')
            }
          },
        },
        {
          title: '根节点',
          width: 150,
          render: (h, { row, index }) => {
            const OptionList = this.fieldTypeList.map((val) => {
              return h(
                'Option',
                {
                  props: {
                    value: val.id + '',
                  },
                  arrts: {
                    key: val.id,
                  },
                },
                val.name
              )
            })
            return h(
              'Select',
              {
                attrs: { value: row.type },
                on: {
                  input: (e) => {
                    this.$set(this.list[index], 'type', e)
                    this.$set(this.list[index], '_disableExpand', +e !== 6)
                  },
                },
              },
              [...OptionList]
            )
          },
        },
        {
          title: ' ',
          width: 220,
          render: (h, { row, index }) => {
            const appendButton = h(
              'Button',
              {
                props: {
                  type: 'default',
                },
                attrs: {
                  style: 'margin-left:10px',
                },
                on: {
                  click: (e) => {
                    this.currentIndex = index
                    this.addType = 2
                    this.isShowVariableModal = true
                  },
                },
              },
              '选择'
            )

            return h(
              'div',
              {
                class: 'inlineBox',
              },
              [
                h('Input', {
                  props: {
                    disabled: +row.type === 6,
                  },
                  attrs: {
                    value: row.name,
                  },
                  on: {
                    'on-blur': (e) => {
                      this.$set(this.list[index], 'name', e.target._value || '')
                    },
                  },
                }),
                appendButton,
              ]
            )
          },
          renderHeader: (h) => {
            const OptionList = this.fieldTypeList.map((val) => {
              return h(
                'Option',
                {
                  props: {
                    value: val.id + '',
                  },
                  arrts: {
                    key: val.id,
                  },
                },
                val.name
              )
            })
            return h(
              'Select',
              {
                attrs: { value: this.rootType, style: 'width:180px;' },
                on: {
                  input: (e) => {
                    this.rootType = e
                  },
                },
              },
              [...OptionList]
            )
          },
        },
        {
          title: '值',
          width: 220,
          render: (h, { row, index }) => {
            const appendButton = h(
              'Button',
              {
                props: {
                  type: 'default',
                },
                attrs: {
                  style: 'margin-left:10px',
                },
                on: {
                  click: (e) => {
                    this.currentIndex = index
                    this.isShowVariableModal = true
                  },
                },
              },
              '选择'
            )

            return h(
              'div',
              {
                class: 'inlineBox',
              },
              [
                h('Input', {
                  props: {
                    disabled: +row.type === 6,
                  },
                  attrs: {
                    value: +row.type === 6 ? '' : row.value,
                  },
                  on: {
                    'on-blur': (e) => {
                      this.$set(
                        this.list[index],
                        'value',
                        e.target._value || ''
                      )
                    },
                  },
                }),
                appendButton,
              ]
            )
          },
        },
        {
          title: ' ',
          width: 160,
          align: 'center',
          render: (h, { row, index }) => {
            const appendButton = h(
              'Button',
              {
                props: {
                  type: 'default',
                },
                attrs: {},
                on: {
                  click: (e) => {
                    this.list.splice(index, 1)
                  },
                },
              },
              '删除'
            )
            const addButton = h(
              'Button',
              {
                props: {
                  type: 'default',
                },
                attrs: {},
                on: {
                  click: (e) => {
                    this.currentIndex = index
                    this.list[index].value = Array.isArray(
                      this.list[index].value
                    )
                      ? this.list[index].value
                      : []
                    this.list[index].value.push({
                      array_type: row.array_type,
                      name: '',
                      type: '2', // 默认字符串
                      order_num: this.list[index].value.length + 1,
                      value: '',
                      _disableExpand: true,
                    })
                  },
                },
              },
              '添加'
            )
            let res = [appendButton]
            if (+row.type === 6) {
              res = [addButton, appendButton]
            }
            return h('div', res)
          },
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return columns
    },
  },
  watch: {
    value: {
      handler: function (val) {
        console.log(val)
        if (val) {
          this.list = val.value || []
        }
      },
      deep: true,
      immediate: true,
    },
    list: {
      handler: function (val) {
        if (val) {
          this.$emit('input', {
            ...this.value,
            value: val,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .inlineBox {
  display: flex;
}
/deep/.ivu-table .ivu-table-stripe {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/pages/taskManage/detail/ExpandTable.vue